import { useBackgroundPathname } from "@/hooks/use-background-pathname";
import { APP_ROUTES } from "@/utils/constants";

export const getRouteConfig = ({ pathname }: { pathname: string }) => {
  switch (true) {
    case pathname.includes(APP_ROUTES.tradeActivity):
    case pathname.includes(APP_ROUTES.tradeTopTraders):
    case pathname.includes(APP_ROUTES.tradePortfolio):
    case pathname.includes(APP_ROUTES.tradeLaunchpad):
    case pathname.includes(APP_ROUTES.trade):
      return true;
    default:
      return false;
  }
};

const useTradePageLayout = () => {
  const pathname = useBackgroundPathname();
  const isTradePage = getRouteConfig({ pathname });

  return {
    isTradePage,
  };
};

export default useTradePageLayout;
